import { GridColDef } from "@mui/x-data-grid";
import { ISorteo } from "../interfaces/interfaces";
import { Box, Button, Stack } from "@mui/material";
import { DescargarPDF } from "../actions/actions";
import { DownloadOutlined, VisibilityOutlined } from "@mui/icons-material";

interface Props {
  VerPDF(
    id: number,
    cantLoteria: number,
    NroSorteo: number,
    modalidad: number,
    fecha: string
  ): void;
  sorteo: ISorteo;
}
export const COLUMNS_SORTEOS: GridColDef<Props>[] = [
  {
    field: "sorteo.NROSorteo",
    headerName: "Sorteo",
    width: 65,
    headerClassName: "textFont",
    cellClassName: "dataFontBase dataFont textAlignLeft paddingTextLeft",
    renderCell: (params) => {
      const { row } = params;
      return <>{`${row.sorteo.NROSorteo}`}</>;
    },
  },
  {
    field: "sorteo.Fecha",
    headerName: "Fecha",
    width: 100,
    headerClassName: "textFont",
    cellClassName: "dataFontBase dataFont textAlignLeft paddingTextLeft",
    renderCell: (params) => {
      const { row } = params;
      return <>{`${row.sorteo.Fecha}`}</>;
    },
  },
  {
    field: "sorteo.Juego",
    headerName: "Juego",
    width: 155,
    headerClassName: "textFont",
    cellClassName: "dataFontBase dataFont textAlignLeft paddingTextLeft",
    renderCell: (params) => {
      const { row } = params;
      return <>{`${row.sorteo.Juego}`}</>;
    },
  },
  {
    field: "sorteo.ID",
    headerName: "[acciones]",
    description: "[acciones]",
    sortable: false,
    width: 185,
    headerClassName: "textFont",
    cellClassName: "dataFontBase dataFont textAlignLeft paddingTextLeft",
    renderCell: (params) => {
      const { row } = params;
      let id: number = row.sorteo.ID;
      let cantLoteria: number = row.sorteo.Loteria.split(",").length;
      let NroSorteo: number = row.sorteo.NROSorteo;
      let modalidad: number = row.sorteo.idJuego;
      let fecha: string = row.sorteo.Fecha2;

      return (
        <>
          <Stack direction={"row"}>
            <Box m={1} alignSelf={"center"}>
              <Button
                variant="outlined"
                color="success"
                size="small"
                title="ver"
                onClick={() => {
                  row.VerPDF(id, cantLoteria, NroSorteo, modalidad, fecha);
                }}
              >
                <VisibilityOutlined />
              </Button>
            </Box>
            <Box m={1} alignSelf={"center"}>
              <Button
                variant="outlined"
                color="success"
                size="small"
                title="descargar"
                onClick={() => {
                  DescargarPDF(
                    id,
                    cantLoteria,
                    NroSorteo,
                    modalidad,
                    fecha
                  ).then(() => {
                    console.log("aa");
                  });
                }}
              >
                <DownloadOutlined />
              </Button>
            </Box>
          </Stack>
        </>
      );
    },
  },
];
